<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;" class="big_box">
				<el-input v-model="value.wenzi" placeholder="请输入内容"> <template slot="prepend">内容</template></el-input>
				<el-input v-model="value.wenzi" placeholder="请输入内容" style="margin-top: 10px;"> <template slot="prepend">链接</template></el-input>
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
				<div style="padding: 20px;" class="big_box">
					<el-input v-model="value.width" placeholder="请输入内容"> <template slot="prepend">宽度</template></el-input>
					<el-input v-model="value.height" placeholder="请输入内容"> <template slot="prepend">高度</template></el-input>
					<el-input v-model="value.color" placeholder="请输入内容"> <template slot="prepend">颜色</template></el-input>
					<el-input v-model="value.size" placeholder="请输入内容"> <template slot="prepend">字号</template></el-input>
					<el-input v-model="value.jiacu" placeholder="请输入内容"> <template slot="prepend">加粗</template></el-input>
					<el-input v-model="value.duiqi" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
					<el-input v-model="value.waibianju" placeholder="请输入内容"> <template slot="prepend">外边距</template></el-input>
					<el-input v-model="value.neibianju" placeholder="请输入内容"> <template slot="prepend">内边距</template></el-input>
					<el-input v-model="value.neibianju" placeholder="请输入内容"> <template slot="prepend">圆角</template></el-input>
				</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		name: 'wenzi_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},

	}
</script>
	<style>
		@import url("Yangshi.css");
	</style>
